import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.css'
import './detail.css'
import './catalog.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
